import React from 'react';
import { Toaster } from 'react-hot-toast';

type ToastContainerProps = {
  isAppView: boolean;
};

const ToastContainer = ({ isAppView }: ToastContainerProps) => {
  return (
    <Toaster
      position="bottom-right"
      containerClassName={`[&>div]:!hidden [&>div:nth-child(-n+2)]:!flex [&_[role=status]]:block ${
        isAppView ? 'mb-10' : ''
      }`}
      toastOptions={{
        duration: 4000,
        style: {
          minWidth: '300px',
          display: 'flex',
          padding: '0',
          background: 'transparent',
          boxShadow: 'none',
          border: 'none'
        },
        success: {
          style: {
            background: 'transparent'
          }
        },
        loading: {
          style: {
            background: 'transparent'
          }
        },
        error: {
          style: {
            background: 'transparent'
          }
        }
      }}
    />
  );
};

export default ToastContainer;
